

const baseUrl = process.env.REACT_APP_BASE_CODE_API;




const apiRoutes = {
  attributionsGetAll: `${baseUrl}/Attributions/All`,
  attributionsGetOne: `${baseUrl}/Attributions/One/:id`,
  attributionsPut: `${baseUrl}/Attributions/Put/:id`,
  attributionsPost: `${baseUrl}/Attributions/Post`,
  attributionsDelete: `${baseUrl}/Attributions/Delete/:id`,

  documentsGetAll: `${baseUrl}/Documents/All`,
  documentsGetOne: `${baseUrl}/Documents/One/:id`,
  documentsPut: `${baseUrl}/Documents/Put/:id`,
  documentsPost: `${baseUrl}/Documents/generate-pdf`,
  documentsDelete: `${baseUrl}/Documents/Delete/:id`,

  documentsCategoriesGetAll: `${baseUrl}/DocumentsCategories/All`,
  documentsCategoriesGetOne: `${baseUrl}/DocumentsCategories/One/:id`,
  documentsCategoriesPut: `${baseUrl}/DocumentsCategories/Put/:id`,
  documentsCategoriesPost: `${baseUrl}/DocumentsCategories/Post`,
  documentsCategoriesDelete: `${baseUrl}/DocumentsCategories/Delete/:id`,

  documentsModelsGetAll: `${baseUrl}/DocumentsModels/All`,
  documentsModelsGetOne: `${baseUrl}/DocumentsModels/One/:id`,
  documentsModelsPut: `${baseUrl}/DocumentsModels/Put/:id`,
  documentsModelsPost: `${baseUrl}/DocumentsModels/Post`,
  documentsModelsDelete: `${baseUrl}/DocumentsModels/Delete/:id`,
  documentsModelsByCat: `${baseUrl}/DocumentsModels/ByCategory/:categoryId`,

  UsersGetAll: `${baseUrl}/Users/All`,
  UsersGetOne: `${baseUrl}/Users/One/:id`,

  LoginLog: `${baseUrl}/Login/log`,


};



export default apiRoutes;

